import { useMemo } from 'react'
import { createContainer } from 'unstated-next'

import { useProductReviewFilters } from '../../lib/hooks/useProductReviewFilters'
import { useProductReviews } from '../../lib/hooks/useProductReviews'
import { useReviewsProductGroupDataContext } from '../ReviewsProductGroupDataService/useReviewsProductGroupData'

const useProductReviewsContainer = () => {
  const { data: productData } = useReviewsProductGroupDataContext()

  const { filters, pageNum } = useProductReviewFilters()

  const { productReviews, productReviewsError, productReviewsStatus } = useProductReviews({
    shopifyProductId: productData?.shopifyProductId ?? '',
    filters,
    pageNum,
  })

  return useMemo(() => {
    return {
      results: productReviews,
      status: productReviewsStatus,
      error: productReviewsError,
    }
  }, [productReviews, productReviewsError, productReviewsStatus])
}

const useProductReviewsWithMediaFilterContainer = () => {
  const { data: productData } = useReviewsProductGroupDataContext()

  const { filters, pageNum } = useProductReviewFilters()

  const {
    productReviews: productReviewsWithMediaFilterResults,
    productReviewsStatus: productReviewsWithMediaFilterStatus,
    productReviewsError: productReviewsWithMediaFilterError,
  } = useProductReviews({
    shopifyProductId: productData?.shopifyProductId ?? '',
    filters: {
      ...filters,
      mediaType: ['photos'],
    },
    pageNum,
  })

  return useMemo(() => {
    return {
      productReviewsWithMediaFilterResults,
      productReviewsWithMediaFilterError,
      productReviewsWithMediaFilterStatus,
    }
  }, [
    productReviewsWithMediaFilterResults,
    productReviewsWithMediaFilterStatus,
    productReviewsWithMediaFilterError,
  ])
}

export const ProductReviewsContainer = createContainer(useProductReviewsContainer)
export const ProductReviewsWithMediaFilterContainer = createContainer(
  useProductReviewsWithMediaFilterContainer
)
